import { parseSensorPositionFormula } from './labelUtils';

export const mapApiLabel = (l) => ({
  id: l.id,
  pk: l.pk_test_ref ?? null,
  t: l.time_unix ?? l.t,
  label: l.label_text ?? l.label,
  note: l.note || '',
  labelType: l.source === 'IA' ? 'IA' : 'JALON',
  iconType: l.source === 'IA' ? 'circle' : 'diamond',
  precision: l.score ? parseFloat(l.score) : null,
  urlSon: l.audio_path ?? l.path ?? null,
  idSensor: l.id_sensor ?? null,
  positionInSensor: l.position_in_sensor ?? null,
});

export const mapApiSection = (s) => ({
  id: s.id,
  idSensor: s.id_sensor,
  pkStart: s.pk_test_ref_start,
  pkEnd: s.pk_test_ref_end,
  tStart: s.time_start ?? s.t_start,
  tEnd: s.time_end ?? s.t_end,
  label: s.phase_text ?? s.label,
  color: s.color_hex ?? s.color,
});

export const mapDraftToApiPayload = (draft) => {
  const { sensorId, position } = parseSensorPositionFormula(draft.sensorAndPosition);
  return {
    id_sensor: sensorId,
    position_in_sensor: position,
    pk_test_ref: draft.pk ?? null,
    time_unix: draft.t,
    label_text: draft.label ?? '',
  };
};
